module.exports = __webpack_public_path__ + "img/overheads-accounting.ce9826c9.svg";